import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DashSelection } from "../app/app.model";

@Component(
    {
        name: 'HeaderComponent',
        components: {
            HeaderNavigation: require('../headernavigation/headernavigation.vue.html').default
        }
    }
)
export default class HeaderComponent extends Vue {
    @Prop({required: true})
    selection!: DashSelection;
}
